import GreenCurve from "./assets/green-curve.svg";
import Logo from "../../assets/images/full_logo.svg";
import Crypto from "../../assets/images/crypto_instant.png";
import GiftCardImage from "../../assets/images/gift_card.png";
import Wallet from "../../assets/images/wallet_instant.png";
import Send from "../../assets/images/send.png";
import Security from "../../assets/images/app-security.png";
import Network from "../../assets/images/network.png";
import { motion } from "framer-motion";

import "./landing.css";
import DashboardImage from "./assets/afr.png";
import { useNavigate } from "react-router";

import { FaLinkedin } from "react-icons/fa";
import { FaTwitterSquare } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import Testimonials from "./testimonial";

const everything = [
  {
    image: Crypto,
    link: "/crypto-exchange",
    title: "Buy/Sell Crypto Instantly",
    description: "Trade BTC, USDT, USDC and ETH with the best real-time rates.",
  },
  {
    image: GiftCardImage,
    link: "/gift-card",
    title: "Exchange Unused Gift Cards for Cash",
    description:
      "Trade Amazon, Steam, Apple, Sephora, Walmart and 300+ global gift cards.",
  },
  {
    image: Wallet,
    link: "/jamestown-wallet",
    title: "Smart Jamestown Wallet",
    description:
      "Deposit, withdraw, save, request payments, and manage your digital funds securely.",
  },
  {
    image: Network,
    link: "/bill-payment",
    title: "Pay Bills Effortlessly",
    description:
      "Electricity, airtime, mobile data, internet subscriptions and more.",
  },
  {
    image: Send,
    link: "/jamestown-wallet",
    title: "Send & Receive Payments Faster Than Usual",
    description:
      "Free transfers between Jamestown users and quick payouts to bank accounts.",
  },
  {
    image: Security,
    link: "#",
    title: "Built with Military-Grade Security",
    description:
      "Advanced encryption, 2FA, withdrawal protection, biometrics & more.",
  },
];

const testimonials = [
  {
    "testimonial": "Jamestown withdrawals are insanely fast. I get my money instantly, every single time.",
    "name": "Tunde A.",
    "location": "Lagos"
  },
  {
    "testimonial": "I trade gift cards on Jamestown because the rates are good and payouts are instant. It’s become my go-to app.",
    "name": "Amina S.",
    "location": "Abuja"
  },
  {
    "testimonial": "Crypto exchange on Jamestown is smooth and profitable. No delays, no stories — just fast settlement.",
    "name": "Chinedu O.",
    "location": "Port Harcourt"
  },
  {
    "testimonial": "I’ve tried many platforms, but Jamestown pays the fastest for gift cards. Once I submit, the money drops.",
    "name": "Michael E.",
    "location": "Asaba, Delta State"
  },
  {
    "testimonial": "Withdrawals are super quick, even on weekends. That’s why I trust Jamestown with my crypto trades.",
    "name": "Efe O.",
    "location": "Warri, Delta State"
  },
  {
    "testimonial": "Jamestown gives better rates and faster payouts than what I used before. Simple app, real results.",
    "name": "Blessing K.",
    "location": "Ibadan"
  },
  {
    "testimonial": "Fast crypto swaps, instant withdrawal, and fair rates. Jamestown actually understands what users want.",
    "name": "Samuel I.",
    "location": "Benin City"
  }
]

export default function LandingPage() {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2, // delay between each card
      },
    },
  };

  const item = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const navigate = useNavigate();

  return (
    <div className="">
      <div className="sm:px-20 px-3">
        <Navbar />
      </div>

      {/* Hero Section */}
      <div className="flex justify-center items-center flex-col mt-10 sm:px-20 px-3">
        <div className="sm:w-[750px] w-full flex justify-center items-center flex-col">
          <h2 className="sm:text-5xl text-3xl font-extrabold text-blue-700 text-center">
            From Trading to Total Financial Freedom.
          </h2>
          {/* <h3 className="sm:text-4xl text-2xl font-bold sm:mt-5 mt-1 text-blue-500">
            Crypto, gift cards, bills, and payments—secured & simplified.
          </h3> */}

          <p className="sm:text-xl p-3 sm:mt-10 mt-5 text-center sm:w-[550px] w-full">
            {/* The highly recommended platform for gift cards, digital remittance,
            and bills payment. Join Jamestown today. */}
            Crypto, gift cards, bills, and payments—secured & simplified.
          </p>

          {/* App Icons */}
          <div className="flex gap-4 mt-6">
            {/* <a
              className="w-fit min-w-[150px] hidden sm:block"
              rel="noreferrer"
              target="_blank"
              href="/register"
            >
              <div className="transition-all ease-in-out duration-200 hover:bg-blue-200 group py-2 rounded-full flex gap-2 items-center justify-center [&amp;_svg]:h-8 [&amp;_svg]:w-8 bg-[#f5f5f5] ">
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 41 40"
                  fill="inherit"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.2501 34.8491C13.2001 34.8491 13.1334 34.8824 13.0834 34.8824C9.8501 33.2824 7.21676 30.6324 5.6001 27.3991C5.6001 27.3491 5.63343 27.2824 5.63343 27.2324C7.66676 27.8324 9.76676 28.2824 11.8501 28.6324C12.2168 30.7324 12.6501 32.8158 13.2501 34.8491Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M35.3999 27.4158C33.7499 30.7324 30.9999 33.4158 27.6499 35.0324C28.2832 32.9158 28.8166 30.7824 29.1666 28.6324C31.2666 28.2824 33.3332 27.8324 35.3666 27.2324C35.3499 27.2991 35.3999 27.3658 35.3999 27.4158Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M35.5332 12.8501C33.4332 12.2168 31.3166 11.7001 29.1666 11.3335C28.8166 9.18346 28.2999 7.05013 27.6499 4.9668C31.0999 6.6168 33.8832 9.40013 35.5332 12.8501Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M13.2501 5.14961C12.6501 7.18294 12.2168 9.24961 11.8668 11.3496C9.7168 11.6829 7.58346 12.2163 5.4668 12.8496C7.08346 9.49961 9.7668 6.74961 13.0835 5.09961C13.1335 5.09961 13.2001 5.14961 13.2501 5.14961Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M26.3164 10.984C22.4498 10.5507 18.5498 10.5507 14.6831 10.984C15.0998 8.70065 15.6331 6.41732 16.3831 4.21732C16.4164 4.08398 16.3998 3.98398 16.4164 3.85065C17.7331 3.53398 19.0831 3.33398 20.4998 3.33398C21.8998 3.33398 23.2664 3.53398 24.5664 3.85065C24.5831 3.98398 24.5831 4.08398 24.6164 4.21732C25.3664 6.43398 25.8998 8.70065 26.3164 10.984Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M11.4835 25.8169C9.1835 25.4003 6.91683 24.8669 4.71683 24.1169C4.5835 24.0836 4.4835 24.1003 4.35016 24.0836C4.0335 22.7669 3.8335 21.4169 3.8335 20.0003C3.8335 18.6003 4.0335 17.2336 4.35016 15.9336C4.4835 15.9169 4.5835 15.9169 4.71683 15.8836C6.9335 15.1503 9.1835 14.6003 11.4835 14.1836C11.0668 18.0503 11.0668 21.9503 11.4835 25.8169Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M37.1666 20.0003C37.1666 21.4169 36.9666 22.7669 36.6499 24.0836C36.5166 24.1003 36.4166 24.0836 36.2833 24.1169C34.0666 24.8503 31.7999 25.4003 29.5166 25.8169C29.9499 21.9503 29.9499 18.0503 29.5166 14.1836C31.7999 14.6003 34.0833 15.1336 36.2833 15.8836C36.4166 15.9169 36.5166 15.9336 36.6499 15.9336C36.9666 17.2503 37.1666 18.6003 37.1666 20.0003Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M26.3164 29.0176C25.8998 31.3176 25.3664 33.5842 24.6164 35.7842C24.5831 35.9176 24.5831 36.0176 24.5664 36.1509C23.2664 36.4676 21.8998 36.6676 20.4998 36.6676C19.0831 36.6676 17.7331 36.4676 16.4164 36.1509C16.3998 36.0176 16.4164 35.9176 16.3831 35.7842C15.6498 33.5676 15.0998 31.3176 14.6831 29.0176C16.6164 29.2342 18.5498 29.3842 20.4998 29.3842C22.4498 29.3842 24.3998 29.2342 26.3164 29.0176Z"
                    fill="inherit"
                  ></path>
                  <path
                    d="M26.7724 26.2729C22.6039 26.7988 18.3964 26.7988 14.2279 26.2729C13.702 22.1044 13.702 17.8969 14.2279 13.7284C18.3964 13.2025 22.6039 13.2025 26.7724 13.7284C27.2983 17.8969 27.2983 22.1044 26.7724 26.2729Z"
                    fill="inherit"
                  ></path>
                </svg>
                <div className="-space-y-1">
                  <p className="text-[10px] text-secondary">Use it on</p>
                  <p className="text-[14px] font-medium text-primary">Web</p>
                </div>
              </div>
            </a> */}
            <a
              className="w-fit min-w-[150px]"
              rel="noreferrer"
              target="_blank"
              href="https://apps.apple.com/us/app/jamestown/id6757491494"
            >
              <div className="transition-all ease-in-out duration-200 hover:bg-blue-200 group py-2 rounded-full flex gap-2 items-center justify-center [&amp;_svg]:h-8 [&amp;_svg]:w-8 bg-[#f5f5f5] ">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 40 40"
                  fill="inherit"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28.4168 33.8C26.7834 35.3833 25.0001 35.1333 23.2834 34.3833C21.4668 33.6167 19.8001 33.5833 17.8834 34.3833C15.4834 35.4167 14.2168 35.1167 12.7834 33.8C4.65011 25.4167 5.85011 12.65 15.0834 12.1833C17.3334 12.3 18.9001 13.4167 20.2168 13.5167C22.1834 13.1167 24.0668 11.9667 26.1668 12.1167C28.6834 12.3167 30.5834 13.3167 31.8334 15.1167C26.6334 18.2333 27.8668 25.0833 32.6334 27C31.6834 29.5 30.4501 31.9833 28.4001 33.8167L28.4168 33.8ZM20.0501 12.0833C19.8001 8.36667 22.8168 5.3 26.2834 5C26.7668 9.3 22.3834 12.5 20.0501 12.0833Z"
                    fill="inherit"
                  ></path>
                </svg>
                <div className="-space-y-1">
                  <p className="text-[10px] text-secondary block">
                    Download on the{" "}
                  </p>
                  <p className="text-[14px] font-medium text-primary">
                    App Store
                  </p>
                </div>
              </div>
            </a>
            <a
              className="w-fit min-w-[150px]"
              rel="noreferrer"
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.jamestown.app.jamestown.jamestown&pcampaignid=web_share"
            >
              <div className="transition-all ease-in-out duration-200 hover:bg-blue-200 group py-2 rounded-full flex gap-2 items-center justify-center [&amp;_svg]:h-8 [&amp;_svg]:w-8 bg-[#f5f5f5] ">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 40 40"
                  fill="inherit"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.5898 19.3602L26.5182 14.4318L10.5998 5.48516C9.54484 4.91516 8.5565 4.83516 7.68984 5.4585L21.5898 19.3602ZM27.3582 25.1302L32.4815 22.2485C33.4815 21.6885 34.0298 20.8952 34.0298 20.0152C34.0298 19.1368 33.4815 18.3418 32.4832 17.7818L27.8448 15.1768L22.6232 20.3968L27.3582 25.1302ZM6.83317 6.67016C6.7265 6.9985 6.6665 7.36516 6.6665 7.76683V32.2752C6.6665 32.9102 6.8065 33.4568 7.05984 33.8918L20.5548 20.3952L6.83317 6.67016ZM21.5898 21.4285L8.16984 34.8502C8.4265 34.9485 8.70317 35.0002 8.99484 35.0002C9.51484 35.0002 10.0565 34.8468 10.6082 34.5402L26.0332 25.8785L21.5898 21.4285Z"
                    fill="inherit"
                  ></path>
                </svg>
                <div className="-space-y-1">
                  <p className="text-[10px] text-secondary">Get it on</p>
                  <p className="text-[14px] font-medium text-primary">
                    Google Play
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="w-full relative flex justify-center mt-6 fadeIn 700ms ease-in forwards">
          <div className="relative w-3/4 md:w-2/3 z-[1] md:min-h-[34vw]">
            <img
              decoding="async"
              loading="lazy"
              src={DashboardImage}
              alt="Dashboard"
              className="i1 w-full rounded-[20px]"
            />
          </div>
          <div className="absolute left-0 h-[100px] md:h-[170px] bottom-[-6.5%] w-full bg-[#00EFC1] z-[0]">
            <img
              src={GreenCurve}
              className="bottom-[-4vw] absolute"
              aria-label="icon"
            />
          </div>
        </div>
      </div>

      {/* Core value proposition Section */}
      <div className="mt-28 sm:px-20 px-3">
        <h2 className="mb-10 mt-24 font-bold text-3xl">
          Core Value Proposition
        </h2>

        <motion.div
          className="grid sm:grid-cols-3 grid-cols-1 gap-8 px-5"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {everything.map((every, index) => (
            <motion.div
              key={index}
              variants={item}
              className="rounded-2xl p-4 border border-gray-400"
              onClick={() => navigate(every.link)}
            >
              <img
                src={every.image}
                alt="Value"
                className="h-[300px] w-full object-cover rounded-md"
              />
              <h5 className="my-5 font-bold text-2xl">{every.title}</h5>
              <p className="font-Rubik text-xl">{every.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Why section */}
      <div className="mt-16 bg-gray-300 py-8">
        <div className="sm:px-20 px-3">
          <h2 className="font-bold text-3xl">Why Jamestown?</h2>
          <h4 className="font-bold text-xl">
            A Modern Digital Asset Platform Built for Africa
          </h4>

          <p className="mt-10 p-2">
            Jamestown gives you everything you need to control your financial
            world — from digital assets to everyday payments. Whether you’re
            buying crypto, selling a gift card, or paying your electricity bill,
            everything is fast, secure and transparent.
          </p>

          <h5 className="font-bold text-xl mt-7">
            Optimized for Speed & Security
          </h5>
          <p className="font-bold">Our system uses:</p>
          <ul className="list-disc pl-10 space-y-1">
            <li>Cold wallet infrastructure</li>
            <li>End-to-end encryption</li>
            <li>Automated fraud detection</li>
            <li>24/7 monitoring</li>
          </ul>

          <div className="flex gap-3 mt-10 justify-center items-center">
            <p className="font-bold">100% Transparency</p>
            <p className="font-bold">
              No hidden fees. No slowdowns. No surpises.
            </p>
          </div>
        </div>
      </div>

      {/* Testimonial */}
      <Testimonials testimonials={testimonials} />

      {/* Footer */}
      <Footer />
    </div>
  );
}

const menu = [
  {
    name: "Products",
    subMenu: [
      {
        name: "Jamestown Wallet",
        link: "/jamestown-wallet",
      },
      {
        name: "Crypto Exchange",
        link: "/crypto-exchange",
      },
      {
        name: "Gift Card Marketplace",
        link: "/gift-card",
      },
      {
        name: "Bill Payments",
        link: "/bill-payment",
      },
    ],
  },
  {
    name: "Company",
    subMenu: [
      {
        name: "About Us",
        link: "/about-us",
      },
      // {
      //   name: "Careers",
      //   link: "/",
      // },
      // {
      //   name: "Security",
      //   link: "/",
      // },
      // {
      //   name: "Press & Media",
      //   link: "/",
      // },
      // {
      //   name: "Contact",
      //   link: "/contact-us",
      // },
      {
        name: "Terms of Use",
        link: "/terms-of-use",
      },
      {
        name: "Privacy Policy",
        link: "/privacy-policy",
      },
    ],
  },
  {
    name: "Support",
    subMenu: [
      {
        name: "Help Center",
        link: "/help-center",
      },
      {
        name: "FAQs",
        link: "/faq",
      },
    ],
  },
];

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-between my-8">
      <img
        src={Logo}
        alt="Logo"
        className="object-cover p-5 cursor-pointer"
        onClick={() => navigate("/")}
      />

      <div className="flex gap-8 items-center">
        {menu.map((m, idx) => (
          <div key={idx} className="relative group">
            {/* Hover trigger (expanded area) */}
            <div className="py-4 cursor-pointer">
              <p className="font-bold text-lg">{m.name}</p>
            </div>

            {/* Sub menu */}
            <div
              className="
          absolute left-0 top-full
          hidden group-hover:block
          bg-white shadow-lg rounded-lg
          min-w-[220px] z-50
        "
            >
              <ul className="py-2">
                {m.subMenu.map((sub, subIdx) => (
                  <li key={subIdx}>
                    <a
                      href={sub.link}
                      className="
                  block px-4 py-2 text-sm
                  text-gray-700
                  hover:bg-gray-100
                "
                    >
                      {sub.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className="sm:flex gap-10 hidden">
        {/* <button
          className="px-7 py-3 text-[15px] font-bold text-center text-lg rounded-full text-dark"
          onClick={() => navigate("/login")}
        >
          Download the app
        </button> */}
        <button
          className="px-7 text-[15px] font-bold py-3 bg-[#00EFC1] text-dark text-center text-lg rounded-full"
          onClick={() => window.open('https://play.google.com/store/apps/details?id=com.jamestown.app.jamestown.jamestown&pcampaignid=web_share', '_blank')}
        >
          Download the app
        </button>
      </div>
    </div>
  );
};

export const Footer = () => {
  return (
    <footer className="mt-10 border-t-[1px] border-e-gray-300">
      <div className="react-reveal sm:px-20 px-3">
        <div className="flex justify-between p-3">
          <div className="w-[60%]">
            <div className="flex items-center p-5">
              <img src={Logo} alt="Logo" />
            </div>
          </div>

          <p className="w-[50%] font-Manrope">
            <span className="font-bold">Jamestown</span> is a modern digital
            finance platform built to help individuals and businesses manage
            money, digital assets and payments with speed, security and
            transparency. We are committed to bridging the gap between
            traditional finance and digital economies across Africa.
          </p>
        </div>
        <div className="">
          {/* Links */}
          <div className="grid grid-cols-4 gap-10 mt-5">
            <div className="flex flex-col gap-6">
              <h5 className="font-bold text-lg">Products</h5>
              <a href="/jamestown-wallet">Jamestown Wallet</a>
              <a href="/crypto-exchange">Crypto Exchange</a>
              <a href="/gift-card">Gift Card Marketplace</a>
              <a href="/bill-payment">Bill Payment</a>
            </div>

            <div className="flex flex-col gap-6">
              <h5 className="font-bold text-lg">Company</h5>
              <a href="/about-us">About Us</a>
              {/* <a href="/contact-us">Contact Us</a> */}
              <a href="/terms-of-use">Terms of Use</a>
              <a href="/privacy-policy">Privacy Policy</a>
            </div>

            <div className="flex flex-col gap-6">
              <h5 className="font-bold text-lg">Support</h5>
              <a href="/help-center">Help Center</a>
              <a href="/faq">FAQs</a>
            </div>

            <div className="flex flex-col gap-6">
              <h5 className="font-bold text-lg">Follow Us</h5>
              <div className="flex gap-5">
                {/* <RiTwitterXFill /> */}
                <FaTwitterSquare
                  size={30}
                  onClick={() =>
                    window.open(
                      "https://x.com/jamestown_ng?s=21&t=a3Oam4PjauwZmcIO4NrdZQ"
                    )
                  }
                  className="cursor-pointer"
                />
                <FaSquareInstagram
                  size={30}
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/jamestown_ng?igsh=MTRwd3c1YXpxYnJwbg%3D%3D&utm_source=qr"
                    )
                  }
                  className="cursor-pointer"
                />
                <FaLinkedin
                  size={30}
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/company/jamestown-global-synergy/"
                    )
                  }
                  className="cursor-pointer"
                />
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="flex items-center justify-between mt-10">
            <span className="text-[#30BCED] text-xs">
              Copyright © {new Date().getFullYear()} jamestown.ng. All Rights
              Reserved
            </span>

            <div className="flex items-center gap-4 text-sm text-gray-500">
              <span>help@jamestown.ng</span>
              <span>+2348145450772, +2348165472851</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
